import { useCallback, useEffect, useState } from "react";

import { deviceRepository } from "@/repositories/deviceRepository";

/**
 * The terminal's device token.
 *
 * Read from local storage rather than held in React state alone, because pairing
 * happens once and must survive every reload thereafter. A PIN sign-in is only
 * accepted from a paired terminal, so this is what makes the till login possible
 * at all.
 */
export function useDeviceToken(): {
  deviceToken: string | null;
  isPaired: boolean;
  /** Re-read after pairing, so the keypad appears without a reload. */
  refresh: () => void;
} {
  const [deviceToken, setDeviceToken] = useState<string | null>(null);
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(() => {
    void deviceRepository.getToken().then((token) => {
      setDeviceToken(token);
      setLoaded(true);
    });
  }, []);

  useEffect(refresh, [refresh]);

  // While loading, report "paired" so the warning banner does not flash on every
  // page load for a terminal that is in fact paired.
  return { deviceToken, isPaired: !loaded || deviceToken !== null, refresh };
}
